import { ShipperCargoCreatePage } from "@/pages/shipper-cargo-create";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_requeired/shipper/cargos/create")({
  component: () => <ShipperCargoCreatePage />,
});
